var scrolledToSlides = false;
var addedFormStyles = false;
var zoomLevel = 100;
var isMobile = window.innerWidth < 780;
var stl_slider;

$(document).on('click', function(e) {
  if(!$(e.target).is('.stl-slide-contact-link') && !$(e.target).closest('.stl-form').length && !$(e.target).closest('.stl-slide-contact-link').length){
    document.querySelector('.stl-form').classList.remove('open');
  }

  if(!$(e.target).closest('.stl-slide-bottom.open').length && !$(e.target).closest('.stl-dot').length){
    e.target.closest('.stl-slide').querySelector('.stl-slide-bottom').classList.remove('open')
    e.target.closest('.stl-slide').querySelectorAll('.stl-slide-tabs-content > div').forEach(function(elm){
        elm.classList.remove('open')
    })
    e.target.closest('.stl-slide').querySelectorAll('.stl-slide-tabs .stl-slide-link').forEach(function(elm){
        elm.classList.remove('active')
    })
  }
  
})

function openSlideTab(tab, elm, keepOpen){
    var isTabOpen = elm.closest('.stl-slide').querySelector(tab).classList.contains('open') && !keepOpen
    elm.closest('.stl-slide').querySelectorAll('.stl-slide-tabs-content > div').forEach(function(elm){
        elm.classList.remove('open')
    })
    elm.closest('.stl-slide').querySelectorAll('.stl-slide-tabs .stl-slide-link').forEach(function(elm){
        elm.classList.remove('active')
    })
    if(isTabOpen){
        elm.closest('.stl-slide').querySelector('.stl-slide-bottom').classList.remove('open')
    }else{

      var innerHeight = elm.closest('.stl-slide').querySelector(tab).querySelector('.stl-slide-text-inner'),
          contentHeight = elm.closest('.stl-slide').querySelector(tab).querySelector('.stl-slide-text-content');


      if(innerHeight &&  contentHeight && contentHeight.offsetHeight > innerHeight.offsetHeight){
        innerHeight.classList.add('scroll')
      }
      
      elm.classList.add('active')  
      elm.closest('.stl-slide').querySelector('.stl-slide-bottom').classList.add('open')
      elm.closest('.stl-slide').querySelector(tab).classList.add('open')  
    }
    
    
}


function disableScroll() { 
    

    window.onmousewheel = function (e) {
      initPage()
    }

   document.addEventListener('touchmove', function (e) {
      initPage()
  });

  if(Shopify.designMode){
    enableScroll()
  }
} 

function initPage() {
  if(scrolledToSlides || Shopify.designMode) return;
      scrolledToSlides = true;
      if(!Shopify.designMode){
            // stl_slider = $('.stl-wrapper').flickity({
            //         adaptiveHeight: true,
            //         wrapAround: true,
            //         //freeScroll: true,
            //         contain: true,
            //           cellAlign: 'left',
            //         prevNextButtons : false,
            //         pageDots:true,
            //         draggable: false,
            //         //fade:true
            //   }).on( 'change.flickity', function( event, index ) {
            //       setTimeout(function() {
            //         $('.is-selected .stl-slide-center').addClass('out');
            //       }, 3000)
            //   });
          }
          jQuery('html,body').animate({ 
                scrollTop: jQuery('.stl-wrapper').offset().top 
            }, 1000, function(){
              
              $('.stl-slide-wrapper').addClass('in');
              
              $( ".stl-slide-images" ).draggable({
                  drag: function(event, ui) {
                      var left = ui.position.left;
                      var top = ui.position.top;
                      var height = ui.helper.height();
                      var width = ui.helper.width();
                      var parent_height = ui.helper.parent().height();
                      var parent_width = ui.helper.parent().width();

                      if(ui.position.top > 0){
                        top = 0;
                      }

                      if((height + ui.position.top) <= parent_height){
                        top = -(height - parent_height);
                      }

                      if(ui.position.left > 0){
                        left = 0;
                      }

                      if((width + ui.position.left) <= parent_width){
                        left = -(width - parent_width);
                      }
                    
                      ui.position = {
                          left: left,
                          top: top
                      };

                  }
                });
              if(!Shopify.designMode){
                  setTimeout(function() {
                    $('.is-selected .stl-slide-center').addClass('out');
                    enableScroll()
                  }, 2000)
              }
              
            });
}
      
function enableScroll() { 
    window.onscroll = function() {}; 
    document.body.classList.add('in')
} 

function scrollHorizontally(event, elm) {
    var delta = Math.max(-1, Math.min(1, (event.wheelDelta || -event.detail)));
    elm.scrollLeft -= (delta * 40); // Adjust the scroll speed here
    event.preventDefault();
}

function switchView(elm, view) {
  elm.closest('.stl-slide').querySelectorAll('.stl-slide-view-link').forEach(function(link){
    link.classList.remove('active')
  })
  elm.closest('.stl-slide').querySelectorAll('[data-view]').forEach(function(link){
    link.classList.remove('active')
  })
  elm.classList.add('active')
  elm.closest('.stl-slide').querySelector('[data-view="'+view+'"]').classList.add('active')
}

function activateItem(item, elm) {
  openSlideTab('.stl-slide-products', elm, true);
  elm.closest('.stl-slide').querySelectorAll('[data-item]').forEach(function(link){
    link.classList.remove('selected')
  })
  elm.closest('.stl-slide').querySelector('[data-item="'+item+'"]').classList.add('selected')
}

function openContactForm() {
  document.querySelector('.stl-form').classList.toggle('open');
  if(!addedFormStyles){
    var sheet = new CSSStyleSheet;
    sheet.replaceSync( `
      [data-testid="app-router"]{
      display:block;
      }
      input,textarea,select { 
        border-radius: 0 !important; 
        border: 1px solid rgb(0, 0, 0) !important;
        box-shadow: none !important;
        text-align: left !important;
      }
      button { 
        border-radius: 30px !important; 
        background: #000 !important;
        padding:18px 0 !important;
        margin-top: 20px !important;
      }
      textarea{
        height: 160px;
      }
      textarea + label{
        font-size:0px !important;
        text-align: left;
        margin: 24px 0px !important;
        padding: 0 20px 0 0 !important;
      }
      textarea + label:after{
        content:'Ask me about adapting this room design to your space or needs — anything from "What color will match my existing walls?” to “what materials are pet safe?"';
        font-size: 16px;
        display: block;
        line-height: 24px;
      }
      textarea:focus + label,
      ._formFieldContainer_1oy4y_5 ._inputFilled_1oy4y_76{
        font-size: 16px !important;
        margin: 0 !important;
      }

       textarea:focus + label:after,
      ._formFieldContainer_1oy4y_5 ._inputFilled_1oy4y_76:after{
        display:none;
      }
      @media (max-width:780px){
       textarea + label:after{
       font-size: 14px;
        line-height: 18px;
       }
      }
    `)
    document.querySelector('#app-embed').shadowRoot.adoptedStyleSheets.push(sheet)
    addedFormStyles = true;
  }
}



function zoomOut(elm) {
        if(zoomLevel > 100) {
            var element = elm.closest('.stl-slide').querySelector('.stl-slide-images');
            var container = elm.closest('.stl-slide');
            var parent_width = container.offsetWidth;
            var parent_height = container.offsetHeight;
          
            zoomLevel -= 10;
            element.style.width = zoomLevel + '%';
            element.style.height = zoomLevel + '%';

            var width = element.offsetWidth;
            var height = element.offsetHeight;
            var height_dif = height - parent_height;
            var width_dif = width - parent_width;
          

            // if(element.style.top > 0){
            //   element.style.top = 0;
            // }

            // if((height + element.style.top) <= parent_height){
            //   element.style.top = -(height - parent_height);
            // }

            // if(element.style.left > 0){
            //   element.style.left = 0;
            // }

            // if((width + element.style.left) <= parent_width){
            //   element.style.left = -(width - parent_width);
            // }

            element.style.top = 0;
            element.style.left = 0;

            if(zoomLevel === 100){
              elm.closest('.stl-slide').querySelector('.stl-slide-zoom-link-out').classList.remove('enabled');
            }
        }
    }

function zoomIn(elm) {
        var element = elm.closest('.stl-slide').querySelector('.stl-slide-images');
        var container = elm.closest('.stl-slide');
        
        var parent_width = container.offsetWidth;
        var parent_height = container.offsetHeight;
        
  
        zoomLevel += 10;
        element.style.width = zoomLevel + '%';
        element.style.height = zoomLevel + '%';

        var width = element.offsetWidth;
        var height = element.offsetHeight;
        var height_dif = height - parent_height;
        var width_dif = width - parent_width;
        var move_left = Math.round((width_dif/2));
        var move_top = Math.round((height_dif/2));
        var current_top = Math.abs(parseFloat(element.style.top || 0));
        var current_left = Math.abs(parseFloat(element.style.left || 0));

        
        if(!element.style.top || current_top < 1 || (move_top/2) == current_top){
          element.style.left = -move_left + 'px';
          element.style.top = -move_top + 'px';
        }
        elm.closest('.stl-slide').querySelector('.stl-slide-zoom-link-out').classList.add('enabled');
    }

if(!isMobile){
  disableScroll()
}


window.onbeforeunload = function () {
  if(!isMobile){
    enableScroll()
    window.scrollTo(0, 0);    
  }
}
window.openSlideTab = openSlideTab;
window.scrollHorizontally = scrollHorizontally;
window.switchView = switchView;
window.openContactForm = openContactForm;
window.zoomIn = zoomIn;
window.zoomOut = zoomOut;